module.exports = __webpack_public_path__ + "media/images/application/template/email-header-9955fc755534a7d3ed49aa68b568a264.jpg";